import i18n from 'i18next';
import moment from 'moment';

const VALID_DATE_FORMAT = 'YYYY-MM-DD';

export const DATE_VALIDATION_WARNING_MSG = i18n.t(
  'inspection.dateValidationWarning',
  'You are trying to upload dates that are not formatted {{format}}. Please correct these to prevent errors in Horizon.',
  { format: VALID_DATE_FORMAT }
);

export const COORDS_VALIDATION_WARNING_MSG = i18n.t(
  'inspection.coordsValidationWarning',
  'You are trying to upload coordinates that are normalized (percentage-based) and not absolute (pixel-based). Please correct these to prevent errors in Horizon.'
);

export const isValidDateFormat = (value: string): boolean => {
  return moment(value, VALID_DATE_FORMAT, true).isValid();
};

export const isValidCoordinates = (value: string): boolean => {
  try {
    const coordinates = JSON.parse(`[${value}]`);

    return (
      Array.isArray(coordinates) &&
      coordinates.every(
        point =>
          Array.isArray(point) && point.length === 2 && point.every(num => num === 0 || num >= 1)
      )
    );
  } catch {
    return false;
  }
};
